export default __webpack_public_path__ + "static/forms_compare_comp1_active-1-b3384bd025ddbe637a7b1fbbaeb04d62.png";